export const beforeItems: string[] = [
  'Planning from scratch',
  'Searching for drills',
  'Repeating the same activities',
  'Improvising progressions',
  'Losing time after work',
]

export const afterItems: string[] = [
  '120 lessons ready',
  'Clear progressions',
  '150 extra drills',
  'Correction library',
  'Assessment system',
  'Backup lessons ready',
]
